import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

function Goal() {
    const value1 = 100;
    const value2 = 150;


    const data1 = {
        labels: ['self'],
        datasets: [{
            data: [value1, 150 - value1],
            backgroundColor: ['#FD7401', '#EDEFFE'],
            borderWidth: 0,
            borderRadius: 5,
            barThickness: 10,
            maxBarThickness: 10,
        }],
    };
    const data2 = {
        labels: ['manager'],
        datasets: [{
            data: [value2, 150 - value2],
            backgroundColor: ['#9A258D', '#EDEFFE'],
            borderWidth: 0,
            borderRadius: 5,
            barThickness: 10,
            maxBarThickness: 10,
        }],
    };


    const options = {
        padding: "0px",
        responsive: true,
        // maintainAspectRatio: true,
        // width: "50",
        // height: "50",
        indexAxis: 'y',
        scales: {
            x: {
                display: false,
                beginAtZero: true,
                max: 150,
            },
            y: {
                display: false,

            },
        },

        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
        },
        layout: {
            padding: {
                left: 0,
                right: 0,
                top: -10,
                bottom: 0,
            },
        },
    };

    return (

        <>
            <div className='' style={{ width: '300px', height: '50px' }}>

                <div className='d-flex justify-content-between  '>
                    <h5 className=''>Technical</h5>
                    <span>{value1}</span>
                </div>
                <Bar data={data1} options={options} />
            </div>
            <div className='mt-3' style={{ width: '300px', height: '50px' }}>

                <div className='d-flex justify-content-between'>
                    <h5 className=''>Communication</h5>
                    <span>{value2}</span>
                </div>
                <Bar data={data2} options={options} />
            </div>

 


        </>
    );
}

export default Goal;









